module.exports = __webpack_public_path__ + "img/sicknotes.c86efa78.svg";